const Footer = () => {
  return (
    <>
      <footer>
        <div>
          <h1>Priyanshu</h1>
          <p>@all right reserved</p>
        </div>

        <div>
        <div>
        <h4>Follow us</h4>
          <a href="#">Youtube</a>
          <a href="https://www.linkedin.com/in/priyanshu-730049240/">Linkdein</a>
          <a href="https://github.com/priyanshu2014204">Github</a>
        </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
